import { ReactElement } from 'react';
import { Skeleton } from '@mui/material';

import { useGetIpfsImageQuery } from 'modules/api/actions/getIpfsImage';
import { IPFS_PREFIX } from 'modules/api/const';

interface IIpfsImageProps {
  className?: string;
  // should be a valid IPFS link, e.g., "ipfs://Qm..."
  ipfsLink?: string;
}

export const isValidIpfsLink = (link: string): boolean => {
  return link ? link.startsWith(IPFS_PREFIX) : false;
};

export function IpfsImage({
  className,
  ipfsLink = '',
}: IIpfsImageProps): ReactElement {
  const { data, isLoading } = useGetIpfsImageQuery(
    { ipfsLink },
    { skip: !isValidIpfsLink(ipfsLink) },
  );

  if (isLoading || !data) {
    return <Skeleton className={className} variant="circular" />;
  }

  return <img alt="" className={className} src={data} />;
}
